import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {of} from 'rxjs/observable/of';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {catchError, tap} from 'rxjs/operators';
import {environment} from '../../environments/environment';

@Injectable()
export class CheckoutService {


  constructor(private http: HttpClient) {
  }

  getPurchase(purchaseId: string): Observable<any> {
    const url = environment.main_url + 'pc/get-purchase/' + purchaseId;
    return this.http.get(url);
  }

  addPurchase(purchase: object): Observable<any> {
    const url = environment.main_url + 'pc/create-purchase';
    const httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/json'})};
    return this.http.post(url, purchase, httpOptions);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/checkout.service.ts